import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const KSLocations = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const locations = [
    "Citylight",
    "Piplod",
    "Pal Adajan",
    "Katargam"
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: "#fff", px: 2 }}>
      <Typography
        variant={isMobile ? "h5" : "h4"}
        align="center"
        sx={{
          fontWeight: "bold",
          fontFamily: "'Playfair Display', serif",
          mb: 4,
        }}
      >
        <Box component="span" sx={{ color: "#FCA500" }}>AB PUNJAB</Box>{" "}
        <Box component="span" sx={{ color: "#E2217D" }}>IN SURAT</Box>
      </Typography>

      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        {locations.map((loc) => (
          <Grid
            item
            key={loc}
            xs={12}
            sm="auto"
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Paper
              elevation={3}
              sx={{
                backgroundColor: "#FCA500",
                color: "#fff",
                fontWeight: "bold",
                textAlign: "center",
                px: 2,
                py: 1,
                borderRadius: 2,
                width: { xs: "100%", sm: 160 },
                maxWidth: 280,
                fontSize: { xs: "0.85rem", sm: "1rem" },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1.3,
                textWrap: "balance",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              {loc}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default KSLocations;
